





































import { Component, Vue } from 'vue-property-decorator'
import matterItem from './components/matterItem.vue'
import {getUndoList, getMineList, changeUndoFocuse} from '@/apis/home'
@Component({
  name: 'MyMatter',
  components: {
    matterItem
  }
})
export default class extends Vue {
  private active: any = ''
  private subActive = 'running'
  private focusStatus = ''
  private list = [] as any []
  private loading = false
  private finished = false
  private page = { pageNumber: 0, pageSize: 20, total: 0 }
  private changeTabs (type) {
    this.$router.push({ path: '/matter/' + type })
    this.active = type
    this.list = []
    this.page = { pageNumber: 0, pageSize: 20, total: 0 }
    this.finished = true
    // this.onLoad(true)
  }
   private beforeRouteUpdate (to, from, next) {
    this.active = to.params.tabName
    this.list = []
    this.page = { pageNumber: 0, pageSize: 20, total: 0 }
    this.finished = true
    this.onLoad(true)
    next()
  }
  private onLoad (isStart = false) {
    let pageNum = this.page.pageNumber + 1
    if (this.active === 'upcoming') {
      this.getUpComingList(pageNum, isStart)
    } else if (this.active === 'initiate') {
      this.getInitiateList(pageNum, isStart)
    }
  }
  private flowStateChange (type) {
    this.subActive = type
    this.getInitiateList(1, true)
  }
  private fouceStateChange (type) {
    this.focusStatus = type
    this.getUpComingList(1, true)
  }
  private handleClick (item) {
    let {processId, nodeId = 'empty'}  = item
    this.$router.push(`/matter/${this.active}/${processId}/${nodeId}`)
  }
  private async getInitiateList (pageNum = 1, isStart) {
    let res = await getMineList({pageNum, pageSize: this.page.pageSize, flowState: this.subActive || undefined})
    if (res.success) {
      this.page.total = res.data.total
      this.page.pageNumber = pageNum
      if (isStart) {
        this.list = res.data.list || []
      } else {
        this.list = this.list.concat(res.data.list)
      }
      this.finished =  this.list.length >= this.page.total
    }
  }
  private async getUpComingList (pageNum = 1, isStart) {
    let res = await getUndoList({pageNum, pageSize: this.page.pageSize, focusStatus: this.focusStatus || undefined})
    if (res.success) {
      this.loading = false
      this.page.total = res.data.total
      this.page.pageNumber = pageNum
      if (isStart) {
        this.list = res.data.list || []
      } else {
        this.list = this.list.concat(res.data.list)
      }
      this.finished =  this.list.length >= this.page.total
    } else {
      this.loading = false
    }
  }
  private async changeUndoFocuse (item, index) {
    let res = await changeUndoFocuse({approvalRecordId: item.approvalRecordId, focusStatus: !item.focusStatus})
    if (res.success) {
      const swipeCells = this.$refs.swipeCell as any[]
      swipeCells[index].close()
      this.$set(item, 'focusStatus', !item.focusStatus)
    }
  }
  private mounted () {
    if (this.$route.params.tabName) {
      let str = this.$route.params.tabName
      this.active = str || ''
    }
    this.changeTabs(this.active || 'upcoming')
    this.onLoad(true)
  }
}
